import { getPreferredProp } from "../../utils";

function isAddressValid({ state, city, required } = {}) {
  const stateValue = getPreferredProp(state, 'value');
  const cityValue = getPreferredProp(city, 'value');

  const isEmpty = !stateValue;
  const hasEnoughInfo = !!cityValue;

  return hasEnoughInfo || (isEmpty && !required);
}

export default isAddressValid;
